import { useRouter } from 'next/router';
// Hooks
import { useOnboardingContext } from 'hooks';
// Constants
import {
  DASHBOARD,
  MANAGE_AMA,
  USER_SCHEDULE_INTERVIEW,
} from 'constants/routes';
// Components
import FullScreenStepperModal from 'components/common3/FullScreenStepperModal/FullScreenStepperModal';
import StartWithMillionsStep from './StartWithMillionsStep/StartWithMillionsStep';
import EcommerceSetup from './EcommerceSetup/EcommerceSetup';
import StreamingSetup from './StreamingSetup/StreamingSetup';
import BrandDealsSetup from './BrandDealsSetup/BrandDealsSetup';

const CreatorSetup = () => {
  const router = useRouter();
  const {
    showCreatorSetupModal,
    setShowCreatorSetupModal,
    isPPVInviteFlow,
    setIsPPVInviteFlow,
  } = useOnboardingContext();

  const isOnScheduleInterviewPage = router.pathname === USER_SCHEDULE_INTERVIEW;
  const isOnManageBrandDealsArea = router.asPath.startsWith(MANAGE_AMA);

  const handleClose = () => {
    setShowCreatorSetupModal(false);

    // Don't redirect to dashboard if:
    // 1. User is in PPV invite flow
    // 2. User is on schedule interview page
    // 3. User is already inside MANAGE_AMA (e.g. ext-talent BD flow already routed them to a campaign page)
    if (
      !isPPVInviteFlow &&
      !isOnScheduleInterviewPage &&
      !isOnManageBrandDealsArea
    ) {
      router.push(DASHBOARD).catch(() => undefined);
    }

    // Reset the flow flag after handling
    setIsPPVInviteFlow(false);
  };

  return (
    <FullScreenStepperModal
      title="START WITH MILLIONS"
      open={showCreatorSetupModal}
      onClose={handleClose}
      footer={{
        showPrevButton: false,
        submitButtonText: 'Skip',
        submitButtonProps: {
          onClick: handleClose,
          variant: 'primary',
          subVariant: 'text',
        },
      }}
    >
      <>
        <StartWithMillionsStep />

        <EcommerceSetup />

        <StreamingSetup />

        <BrandDealsSetup />
      </>
    </FullScreenStepperModal>
  );
};

export default CreatorSetup;
